import { DEFAULT_DATE_FORMAT } from 'product_modules/utils/valueFormatters/base/constants';
import { CorrespondenceChecker } from 'product_modules/utils/valueVisualTypeCorrespondenceCheckers/Types';
import { VariableValue } from 'product_modules/api/Types';
import DateTimeUtils from 'product_modules/utils/dateUtils';

const isCorrespondsDate: CorrespondenceChecker<string> = (value: VariableValue): value is string => {
  if (typeof value !== 'string') {
    return false;
  }

  const date = DateTimeUtils.parse(value, DEFAULT_DATE_FORMAT);

  return date.isValid();
};

export default isCorrespondsDate;
